import type {ProviderCategory, ProviderMethod} from "@/types/provider-method.types";
import {type ApiPagination, type NormalizedPagination, normalizePagination} from "@/utils/pagination";

export interface ProviderMethodApiResponse {
  id: string;
  payment_provider_id: string;
  provider_code: string;
  provider_name: string;
  category: string;
  country_code: string;
  country_name: string;
  currency: string;
  operation_type: string;
  min_amount_cents: number;
  max_amount_cents: number;
  commission_percentage: number;
  commission_fixed_cents: number;
  processing_time: string;
  icon: string;
  requires_email: boolean;
  requires_phone: boolean;
  requires_bank_account: boolean;
  requires_beneficiary_name: boolean;
  requires_beneficiary_doc: boolean;
  requires_wallet_address: boolean;
  requires_network: boolean;
  is_active: boolean;
  display_order: number;
  metadata: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export const toProviderMethod = (raw: ProviderMethodApiResponse): ProviderMethod => ({
  id: raw.id,
  paymentProviderId: raw.payment_provider_id,
  providerCode: raw.provider_code,
  providerName: raw.provider_name,
  category: raw.category as ProviderCategory,
  countryCode: raw.country_code,
  countryName: raw.country_name,
  currency: raw.currency,
  operationType: raw.operation_type === "withdrawal" ? "withdrawal" : "deposit",
  minAmountCents: raw.min_amount_cents,
  maxAmountCents: raw.max_amount_cents,
  commissionPercentage: raw.commission_percentage,
  commissionFixedCents: raw.commission_fixed_cents,
  processingTime: raw.processing_time,
  icon: raw.icon,
  requiresEmail: raw.requires_email,
  requiresPhone: raw.requires_phone,
  requiresBankAccount: raw.requires_bank_account,
  requiresBeneficiaryName: raw.requires_beneficiary_name,
  requiresBeneficiaryDoc: raw.requires_beneficiary_doc,
  requiresWalletAddress: raw.requires_wallet_address,
  requiresNetwork: raw.requires_network,
  isActive: raw.is_active,
  displayOrder: raw.display_order,
  metadata: raw.metadata ?? {},
  createdAt: raw.created_at,
  updatedAt: raw.updated_at,
});

export const toProviderMethodsPage = (
  items: ProviderMethodApiResponse[],
  pagination: ApiPagination
): {items: ProviderMethod[]; pagination: NormalizedPagination} => ({
  items: items.map(toProviderMethod),
  pagination: normalizePagination(pagination),
});
